<div class="auth-card">
  <div class="dx-card content">
    <!-- Logo: vive ÚNICAMENTE en la card del form. Los logos del
         brand-panel y del mobile-brand están removidos para evitar
         duplicación visual. -->
    <div class="form-logo" aria-hidden="true">
      <span class="form-logo-pill">
        <img src="assets/img/ionics-logo.gif" alt="IONICS"/>
      </span>
    </div>

    <div class="header">
      <div class="title">{{ title }}</div>
      <div class="description" *ngIf="description">{{ description }}</div>
    </div>

    <ng-content></ng-content>
  </div>
</div>
